import type { UnlockedCouponTokens } from "../../../../aysa_api/features/coupon/v1/unlocked_coupon_tokens.types";
import { Reader, Writer } from "protobufjs/minimal";

export const createBaseUnlockedCouponTokens = (): UnlockedCouponTokens => {
  return {
    unlockedCouponTokens: [],
  };
};

export const decodeUnlockedCouponTokens = (
  reader: Reader,
  length: number
): UnlockedCouponTokens => {
  const end = reader.pos + length;
  const message = createBaseUnlockedCouponTokens();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.unlockedCouponTokens.push(reader.string());

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeUnlockedCouponTokens = (
  writer: Writer,
  message: UnlockedCouponTokens
): Writer => {
  for (const value of message.unlockedCouponTokens) {
    writer.uint32(10).string(value);
  }

  return writer;
};
